import { animateScroll } from 'react-scroll'
import {
  FreeCouponListQueryOption,
  useCustomQuery,
} from 'src/hooks/react-query/useCustomQuery.hook'
import { FreeCouponListSpace } from 'src/types/api'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import { DateUtils } from 'src/utils/date'
import { useEffect } from 'react'

const usePartnerEntry = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const redirectPathParam = searchParams.get('redirectPath')
  const pCodeParam = searchParams.get('pCode')
  const enterRedirectPath = sessionStorage.getItem('enterRedirectPath') || ''
  const [, setCookie] = useCookies(['app_install_popup'])
  const { cookieNoneAppInstallPopupTime } = DateUtils

  /** pCode 값 */
  const pCode = pCodeParam ?? sessionStorage.getItem('pCode')

  const isAlyac = pCode?.includes('alyac') ?? false

  /** 무료쿠폰 리스트 조회 */
  const { isLoading: isFreeCouponListLoading, refetch: freeCouponListRefetch } =
    useCustomQuery<FreeCouponListSpace.Response>(FreeCouponListQueryOption(false))

  /** 제휴사에서 진입 정보 저장 */
  const saveStoragePartnerEntryInfo = () => {
    if (!pCodeParam && !redirectPathParam) return

    if (pCodeParam) {
      sessionStorage.setItem('pCode', pCodeParam)
    }
    if (redirectPathParam) {
      sessionStorage.setItem('enterRedirectPath', redirectPathParam)
    }
  }

  /** 리다이렉트 정보 초기화 */
  const resetEnterRedirectValues = () => {
    sessionStorage.removeItem('enterRedirectPath')
  }

  /** 리다이렉트 처리 */
  const handleEnterRedirect = async (redirectPath?: string) => {
    if (!enterRedirectPath && !redirectPath) return true

    animateScroll.scrollToTop({ duration: 0, smooth: false })

    setCookie('app_install_popup', true, {
      path: '/',
      expires: cookieNoneAppInstallPopupTime(),
    })

    // 종점이 메인페이지가 아닌 경우 히스토리에 넣어주기
    navigate({ pathname: '/web/main' }, { replace: true })

    /** 상시할인 카테고리별별 리다이렉트 */
    if (enterRedirectPath?.includes('always') || redirectPath?.includes('always')) {
      const alwaysCategory = enterRedirectPath?.includes('always')
        ? enterRedirectPath.split('_')[1]
        : redirectPath?.split('_')[1]
      navigate(`/web/always/${alwaysCategory}`)
    }

    /** 무료쿠폰 상세 리다이렉트 */
    if (enterRedirectPath?.includes('free_coupon') || redirectPath?.includes('free_coupon')) {
      const freeCoupon = await freeCouponListRefetch?.().then((res) => {
        return (
          res?.data?.Body?.FreeCoupon?.flatMap(
            (group: FreeCouponListSpace.FreeCouponTypes) => group.Coupons ?? [],
          )?.[0] ?? null
        )
      })

      if (
        !!freeCoupon?.Idx &&
        freeCoupon.Idx > 0 &&
        (freeCoupon.Status === 0 || freeCoupon.Status === 1)
      ) {
        navigate(`/web/coupon/free_coupon/${freeCoupon.Idx}`)
      } else {
        navigate(`/web/coupon/free_coupon`)
      }
    }

    resetEnterRedirectValues()

    return false
  }

  useEffect(() => {
    saveStoragePartnerEntryInfo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    value: { pCode },
    redirectFunction: {
      handleEnterRedirect,
      resetEnterRedirectValues,
      isFreeCouponListLoading,
    },
    pageValue: { joinCert: { isShowMonthlyBenefitFeePartner: isAlyac } },
  }
}

export default usePartnerEntry
